import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import ConvenienceExportModal from 'components/Modals/ExportModal/ConvenienceExportModal'
import { getConvenienceList, getConvenienceSummary } from 'services/places'
import { ConvenienceFilterset } from './ConvenienceFilterset'
import { useConvenienceTableCols } from './ConvenienceTableColumns'

const sortableFields: string[] = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'domain',
  'reviews_avg',
  'reviews_cnt',
  'doors_cnt',
]

export const convenienceTableConfig = defineTargetTableConfig({
  // Convenience chain detail link reads `cstore.id` (GooglePlaceBase name cell,
  // accesor="cstore"). App vertical `convenience` maps to unified `cstore`.
  vertical: 'convenience',
  rowConfig: { nestKey: 'cstore' },
  filterIdentifier: 'CONVENIENCE_TABLE',
  savedPresetsIdentifier: 'CONVENIENCE_TABLE',
  companyTypeSlug: 'convenience',
  tableTypeSlug: 'convenience',
  sortableFields,
  preferredGroupOrder: ['Target Attributes', 'Campaigns and Deals'],
  searchPlaceholder: 'Search convenience by name',
  useColumns: useConvenienceTableCols,
  Filterset: ConvenienceFilterset,
  ExportModal: ConvenienceExportModal,
  // dev moved the convenience list/summary fetchers off the `api` service hook
  // (`api.getConvenienceList`) to standalone exports in `services/places`.
  resolveLegacyActions: () => ({
    listAction: getConvenienceList,
    summaryAction: getConvenienceSummary,
  }),
})

export function ConvenienceTable(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={convenienceTableConfig} {...props} />
}
